import { BRAND, EDITORIAL_SHADOW } from '../palette';
import { SFL_PRODUCTS, type SflFundCode } from '../sflProducts';

/**
 * Two product tabs: Siji Fixed Link (IDR) and Siji Fixed Link (Dollar).
 * SFIS is intentionally absent — this page only handles the two SFL variations.
 */
export function SflProductTabs({
  selected,
  onSelect,
}: {
  selected: SflFundCode;
  onSelect: (code: SflFundCode) => void;
}) {
  return (
    <div
      className="sfl-tabs flex gap-0.5 w-fit max-w-full"
      style={{
        background: BRAND.track,
        border: `1px solid ${BRAND.panelBorder}`,
        borderRadius: 10,
        padding: 4,
      }}
      role="tablist"
      aria-label="Produk Siji Fixed Link"
    >
      {SFL_PRODUCTS.map((product) => {
        const isActive = selected === product.code;
        return (
          <button
            key={product.code}
            type="button"
            role="tab"
            aria-selected={isActive}
            id={`tab-${product.code}`}
            onClick={() => onSelect(product.code)}
            style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 13.5,
              letterSpacing: '0.3px',
              color: isActive ? BRAND.red : BRAND.textDim,
              background: isActive ? BRAND.panel : 'transparent',
              border: 'none',
              padding: '11px 26px',
              borderRadius: 7,
              cursor: 'pointer',
              fontWeight: isActive ? 600 : 400,
              boxShadow: isActive
                ? `inset 0 0 0 1px rgba(234,27,26,0.30), ${EDITORIAL_SHADOW}`
                : 'none',
            }}
          >
            {product.tabLabel}
          </button>
        );
      })}
    </div>
  );
}
